/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Large_Json_Files_H1Inputs */

const en_guide_large_json_files_h1 = /** @type {(inputs: Guide_Large_Json_Files_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Working with Large JSON Files: Tips and Best Practices`)
};

const ko_guide_large_json_files_h1 = /** @type {(inputs: Guide_Large_Json_Files_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`대용량 JSON 파일 다루기: 팁과 모범 사례`)
};

const ja_guide_large_json_files_h1 = /** @type {(inputs: Guide_Large_Json_Files_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大きなJSONファイルの扱い方：ヒントとベストプラクティス`)
};

/**
* | output |
* | --- |
* | "Working with Large JSON Files: Tips and Best Practices" |
*
* @param {Guide_Large_Json_Files_H1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_large_json_files_h1 = /** @type {((inputs?: Guide_Large_Json_Files_H1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Large_Json_Files_H1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_large_json_files_h1(inputs)
	if (locale === "ko") return ko_guide_large_json_files_h1(inputs)
	return ja_guide_large_json_files_h1(inputs)
});